<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        {{data.action | titlecase }} {{ type }}
    </div>
    <div>
        <mat-icon
            mat-dialog-close
            [svgIcon]="'heroicons_solid:x-mark'"
        ></mat-icon>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content>
    <div class="grid grid-cols-1 gap-2">
        <div class="w-full">
            <mat-form-field class="w-full">
                <mat-label>Activity Name</mat-label>
                <input matInput [(ngModel)]="payload.activityName" />
            </mat-form-field>
        </div>
        <div class="w-full">
            <mat-form-field class="w-full">
                <mat-label>Activity Completion</mat-label>
                <input matInput [(ngModel)]="payload.activityCompletion" />
                <span matTextSuffix>%</span>
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-error" (click)="deleteRecord()" *ngIf="data.action == 'edit'">Delete</button>
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-primary" (click)="save()">Save</button>
</mat-dialog-actions>
